import { render, staticRenderFns } from "./workIcon.vue?vue&type=template&id=34b91b43&scoped=true&"
import script from "./workIcon.vue?vue&type=script&lang=js&"
export * from "./workIcon.vue?vue&type=script&lang=js&"
import style0 from "./workIcon.vue?vue&type=style&index=0&id=34b91b43&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b91b43",
  null
  
)

export default component.exports